import React from 'react';
import { List, Datagrid, required,
		RefreshButton,FunctionField ,DateInput,Filter,
		TextField, NumberField} from 'admin-on-rest';

import CHUrlField from '../utils/CHUrlField'
import CHEurField from '../utils/CHEurField'

import RaisedButton from 'material-ui/RaisedButton';

import { CardActions, Card, CardText } from 'material-ui/Card';

import AdsSiteSelector from './AdsSiteSelector'
import ContentAdd from 'material-ui/svg-icons/content/add';
import ActionHelp from 'material-ui/svg-icons/action/help';
import ActionWarning from 'material-ui/svg-icons/alert/error';

import { Link } from 'react-router-dom';
import UpdateAdStatusButton from './buttons/UpdateAdStatusButton';
import UpdateCpcButton from './buttons/UpdateCpcButton';
import OpenAdDetailsButton from './buttons/OpenAdDetailsButton';

const descriptionStyle = {
	display: 'block',	
	minHeight: 60,
	marginBottom: '15px',
}
const styles = {
	cardActions : {	padding: '10px' },
	raisedButton: { background: '#fd9512', color: '#fff', textTransform: 'upppercase' },
	descriptionCard: {marginBottom: '25px' },
	boldText: {fontWeight: 'bold'},
	primaryText: {color: '#284263'},
	actionHelp: {width: 35,height:35,color: '#ddd',marginTop: '5px'},
	leftDiv: {width: '5%',float:'left', textAlign:'center', paddingRight: '10px'},
	rightDiv: {width: '94%',float:'left'},
	row: {display: 'flex',flexWrap: 'wrap', color: '#676767',marginTop: '5px', lineHeight: '22px'},
	cardText: {padding: '10px 15px 5px 10px'},
	cardActionStyle: {paddingTop: '15px'},
	datagridStyles : {
		table: { },
		tbody: { },
		tr: { },
		header: {
			th: { padding: '5px 3px', color: '#516987', textTransform: 'lowercase'  },
			'th:first-child': {padding: '5px 3px', color: '#516987'  }, // special style for the first header column
		},
		cell: {
			td: { padding: '2px 19px' },
			'td:first-child': { padding: '2px 19px' }, // special style for the first column
		},
	}
}



/*
[{
   "id": 1,
   "ad_active": true,
   "ad_status": "In afwachting",
   "bid": 2,
   "bid_changed_on": "2018-04-04T15:00:00.000Z",
   "clicks": 5,
   "cloudhintsdomains_id": 1,
   "title": "vergelijk-boekhoudprogramma.nl",
   "website_url": "https://www.vergelijk-boekhoudprogramma.nl",
   "minimum_cpc": 1.5,
   "foo": "domain"
}]
*/

const PostActions = ({ resource, filters, displayedFilters, filterValues, basePath, showFilter }) => (
    <CardActions style={styles.cardActionStyle}>
        {filters && React.cloneElement(filters, { resource, showFilter, displayedFilters, filterValues, context: 'button' }) }
       	
		<RaisedButton primary label='Nieuwe advertentie' icon={<ContentAdd />} 
				containerElement={<Link to={`${basePath}/create`} />}/>		
        <RefreshButton />
    </CardActions>
);

/* ` */

const gridRowStyle = (record, index) => ({
   	borderBottomStyle: 'solid',
	borderTopStyle: 'solid',
	fontWeight: record.calc_row == true ? 'bold' : 'normal',
	borderBottomWidth: record.calc_row == true ? '0px' : '1px',
	borderTopWidth: record.calc_row == true ? '2px' : '1px',	
	borderColor: record.calc_row == true ? '#ccc' : '#eee',
});

const AdsFilter = (props) => (
    <Filter {...props} className="filter">			
		<DateInput source="to_date" label="Tot en met datum" alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een tot en met datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl'
			}} />
			
		<DateInput source="initialfilter_from_date" label="Van datum" defaultValue={props.date} alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een van datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl',
			}} />
			
    </Filter>
);

/* 
<AdDetailsButton source="adDetails" sortable={false} source='id' disp='Bewerken' label="Wijzigen" />
<OpenAdDetailsButton source="adDetails" sortable={false} source='id' disp='Bewerken' label="Wijzigen" />
	Deze in de grid zetten voor extra kolom die ad details opent voor planfield bewerken		
*/

export const AdsList = (props) => (
   <div className="list-con-lowercase">
	
	
	
   <Card style={styles.descriptionCard}><CardText style={styles.cardText}>
  		<div style={styles.row}>
			<div style={styles.leftDiv}>
			<ActionHelp style={styles.actionHelp} />
			</div>
			<div style={styles.rightDiv}>			
			Hieronder kunt u uw plaatsingen beheren. Klik op de knop <strong style={styles.boldText}>'Nieuwe advertentie'</strong> om u aan te melden voor een vergelijkingssite. 
			U kunt per plaatsing een eigen <strong style={styles.boldText}>CPC</strong> (bieding per klik naar uw website) instellen. 
			Let op, het kan tot <strong style={styles.boldText}>10 minuten</strong> duren voordat een gewijzigde bieding zichtbaar is op onze websites. 
			</div>
		</div>
   </CardText>
   </Card>
	
	<Card style={styles.descriptionCard}>
		<CardText style={styles.cardText}>
			<div style={styles.row}>
				<div style={styles.leftDiv}>
				<ActionWarning style={styles.actionHelp} />
				</div>
				<div style={styles.rightDiv}>			
				<span style={styles.note}>Let op: het is nog niet mogelijk om de inhoud van uw plaatsing (zoals website informatie, prijzen, screenshots, etc) te behren via de portal. U ontvangt na het toevoegen van een advertentie een e-mail met een formulier om deze informatie aan uw advertentie toe te voegen.</span>
				</div>
			</div>
	   </CardText>
   </Card>
	
	<List title="Mijn advertenties" className="list" {...props} perPage={50} filters={<AdsFilter date={new Date(new Date().getFullYear(), new Date().getMonth(), 1,0,0,0)} />} 
												actions={<PostActions />} >
		<Datagrid styles={styles.datagridStyles} perPage={50} rowStyle={gridRowStyle}>
            
			
			<CHUrlField source="website_url" source_disp="title" label="Website" sortable={false} />
            <CHEurField source="minimum_cpc" label="Min. CPC" source_disp="title" sortable={false} showTime />	
            <UpdateCpcButton source="bid" label="Bieding (CPC)" sortable={false} />
	        <TextField className='adStatus' source="ad_status" label="Status plaatsing" sortable={false}  />	
	        <TextField source="cost" label="Kosten" sortable={false} />	
			<TextField source="avgcpc" sortable={false}  label="Gem. CPC" />	
			<TextField source="clickscalc" sortable={false}  label="Kliks" />		
			<UpdateAdStatusButton source="toggleStatus" sortable={false}  label="In/uitschakelen" />
			
			
        </Datagrid>
    </List>
	</div>
);



export const AdsSiteSelectorPage = (props) => (
  	 <AdsSiteSelector />
);


// WEBPACK FOOTER //
// ./src/ads/Ads.js